var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isBatchManager === true)?_c('div',[_c('BatchManager',{key:_vm.componentKey})],1):_c('div',[_c('BatchClassic',{key:_vm.componentKey})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }